<template>
  <div id="app">
    <Header />
    <!-- <router-view/> -->
    <router-view v-slot="{ Component }">
      <transition name="show" mode="out-in">
        <component :is="Component" />
      </transition>
    </router-view>

    <Footer />
  </div>
</template>
<script>
import Header from './components/Header.vue';
import Footer from './components/Footer.vue';

  export default {
    components: { 
      Header,
      Footer,
    }
}
</script>
<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
#app {
  /* font-family: Avenir, Helvetica, Arial, sans-serif; */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-size: 14px;
}
a{
  text-decoration: none;
  color: inherit;
}
.show-enter-active,
.show-leave-active {
  transition: opacity 0.5s ease;
}
.show-enter-from,
.show-leave-to {
  opacity: 0;
} 


</style>
